<div class="sidepanel-toolbox">
    <div class="sidepanel-toolbox-item" id="sidepanel-toolbox-div">
        <!-- <button *ngIf="!hideDeselectButton" class="sidepanel-toolbox-button-deselect" (click)="toggleItem(null)">Deselect Item</button> -->
        <button *ngFor="let item of source" [ngClass]="getClassByActivity(item)" (click)="toggleItem(item)" [disabled]="isDisabled(item)">
      <img style="background-color:white;" [height]="40" [width]="40" draggable="true" src="../../assets/editorItems/{{item.getImageComponent().srcName}}">
            <span>{{item.getName()}}</span>
        </button>
    </div>
</div>
